import PlateInput from './plate-input';

export default PlateInput;
